import React from "react";
import icon24h from "./../../images/24hours.png";
import icon6h from "./../../images/6hours.png";

const DaySelector = ({ perDay, setPerDay }) => {
  return (
    <span>
      {/* eslint-disable-next-line */}
      <a
        className={`button--neutral-${perDay ? "on" : "off"} is-right`}
        onClick={() => {
          setPerDay(true);
        }}
      >
        <img alt="" src={icon24h} />
      </a>
      {/* eslint-disable-next-line */}
      <a
        className={`button--neutral-${perDay ? "off" : "on"} is-right`}
        onClick={() => {
          setPerDay(false);
        }}
      >
        <img alt="" src={icon6h} />
      </a>
    </span>
  );
};

export default DaySelector;
